import humanInspectionPng from '../../imgs/humaninspection@2x.png';
import robotPng from '../../imgs/robot@2x.png';
import robotDogPng from '../../imgs/robotdog@2x.png';
import electricityPng from '../../imgs/icon-electricity@2x.png';
import waterPng from '../../imgs/icon-water@2x.png';
import gasPng from '../../imgs/icon-gas@2x.png';

export enum AlarmLevel {
  HIGHEST,
  HIGH,
  MIDDLE,
  LOW,
  LOWEST,
}

export const AlarmLevelDisplay = {
  [AlarmLevel.HIGHEST]: '最高级',
  [AlarmLevel.HIGH]: '高级',
  [AlarmLevel.MIDDLE]: '中级',
  [AlarmLevel.LOW]: '低级',
  [AlarmLevel.LOWEST]: '最低级',
};

export const AlarmLevelColorDisplay = {
  [AlarmLevel.HIGHEST]: 'var(--mx-diagram12-color)',
  [AlarmLevel.HIGH]: 'var(--mx-diagram3-color)',
  [AlarmLevel.MIDDLE]: 'var(--mx-diagram6-color)',
  [AlarmLevel.LOW]: 'var(--mx-diagram5-color)',
  [AlarmLevel.LOWEST]: 'var(--mx-diagram7-color)',
};

// 任务类型
export enum TaskType {
  //  巡检
  INSPECTION,
  // 工单
  WORK_ORDER,
}

export const TaskTypeDisplay = {
  [TaskType.INSPECTION]: '巡检',
  [TaskType.WORK_ORDER]: '工单',
};

export const TaskTypeColors = {
  [TaskType.INSPECTION]: '#16DD8E',
  [TaskType.WORK_ORDER]: '#854ECA',
};

// 任务场景
export enum TaskScene {
  // 电
  ELECTRICITY = 1,
  // 水
  WATER,
  // 气
  GAS,
}

export const TaskSceneDisplay = {
  [TaskScene.ELECTRICITY]: '电',
  [TaskScene.WATER]: '水',
  [TaskScene.GAS]: '气',
};

export const TaskSceneColors = {
  [TaskScene.ELECTRICITY]: '#57FB8B',
  [TaskScene.WATER]: '#2D8DFF',
  [TaskScene.GAS]: '#FFCB47',
};

export const TaskSceneImg = {
  [TaskScene.ELECTRICITY]: electricityPng,
  [TaskScene.WATER]: waterPng,
  [TaskScene.GAS]: gasPng,
};

// 巡检分类
export enum InspectionCategory {
  //  人工巡检
  HUMAN_INSPECTION,
  // 机器人
  ROBOT,
  // 机器狗
  ROBOT_DOG,
}

export const InspectionCategoryDisplay = {
  [InspectionCategory.HUMAN_INSPECTION]: '人工巡检',
  [InspectionCategory.ROBOT]: '导轨机器人',
  [InspectionCategory.ROBOT_DOG]: '四足机器人',
};
export const InspectionCategoryImg = {
  [InspectionCategory.HUMAN_INSPECTION]: humanInspectionPng,
  [InspectionCategory.ROBOT]: robotPng,
  [InspectionCategory.ROBOT_DOG]: robotDogPng,
};

export enum RobotStatus {
  // 离线
  OFF,
  // 在线
  ON,
}

export enum InspectStatus {
  // 空闲
  IDLE,
  // 运行
  RUNNING,
}

// 可见光摄像头通讯状态
export enum IpcStatus {
  // 离线
  OFF,
  // 在线
  ON,
}

// 红外摄像头通讯状态
export enum ThermalIpcStatus {
  // 离线
  OFF,
  // 在线
  ON,
}

// 音频设备通讯状态
export enum AudioStatus {
  // 离线
  OFF,
  // 在线
  ON,
}

export const InspectStatusDisplay = {
  [InspectStatus.IDLE]: '空闲中',
  [InspectStatus.RUNNING]: '正在巡检',
};

export const IpcStatusDisplay = {
  [IpcStatus.OFF]: '离线',
  [IpcStatus.ON]: '在线',
};

export const ThermalIpcStatusDisplay = {
  [ThermalIpcStatus.OFF]: '离线',
  [ThermalIpcStatus.ON]: '在线',
};
export const AudioStatusDisplay = {
  [AudioStatus.OFF]: '离线',
  [AudioStatus.ON]: '在线',
};
